import { z } from 'zod';

/** Search params of the message screens (TanStack Router validateSearch). Bad values fall back to "no filter". */

const str = z
  .union([z.string(), z.number()])
  .transform((v) => String(v))
  .optional()
  .catch(undefined);

export const LOG_TYPES = ['alert', 'batch', 'daily', 'weekly', 'test', 'chat', 'api'] as const;

export const messagesSearchSchema = z.object({
  status: str,
  client: str,
  type: z.enum(LOG_TYPES).optional().catch(undefined),
  date: z.enum(['today', 'yesterday', '7d', 'all']).optional().catch(undefined),
  q: str,
  open: str,
});
export type MessagesSearch = z.infer<typeof messagesSearchSchema>;

/**
 * /messages validateSearch. Accepts `?clientId=` as an alias of `?client=` (links from other screens use the
 * entity name) and drops unknown keys, so every in-app deep link lands on the right filter / open message.
 */
export function parseMessagesSearch(raw: Record<string, unknown>): MessagesSearch {
  const { clientId, ...rest } = raw;
  return messagesSearchSchema.parse(rest.client == null && clientId != null ? { ...rest, client: clientId } : rest);
}

export const clientMessagesSearchSchema = z.object({
  site: str,
  status: str,
  type: z.enum(LOG_TYPES).optional().catch(undefined),
  open: str,
});
export type ClientMessagesSearch = z.infer<typeof clientMessagesSearchSchema>;
